export const OVERPAYMENT_TYPE_LOCKED_MESSAGE = 'The type of an Overpayment credit cannot be changed.';
//# sourceMappingURL=overpayment-type-locked-message.js.map